import React from "react";

const Dashboard = ({ organizations, employees, roles, setActiveView }) => {
  // Last 3 organizations
  const recentOrganizations = [...organizations]
    .sort((a, b) => new Date(b.registrationDate) - new Date(a.registrationDate))
    .slice(0, 3);

  // Last 3 employees
  const recentEmployees = [...employees]
    .sort((a, b) => new Date(b.hireDate) - new Date(a.hireDate))
    .slice(0, 3);

  // Last 3 roles
  const recentRoles = [...roles]
    .sort(
      (a, b) =>
        new Date(b.createdAt || "2023-01-01") -
        new Date(a.createdAt || "2023-01-01"),
    )
    .slice(0, 3);

  return (
    <div className="dashboard-view">
      <h2>Dashboard</h2>

      <div className="dashboard">
        <div className="dashboard-card">
          <h3>
            <span>🏢</span> Organizations
          </h3>
          <div className="stat-number">{organizations.length}</div>
          <p>Total registered organizations</p>

          <h4 style={{ marginTop: "1.5rem" }}>Recently Registered</h4>
          <ul className="recent-list">
            {recentOrganizations.map((org) => (
              <li key={org.id}>
                <span>{org.name}</span>
                <span>{org.registrationDate}</span>
              </li>
            ))}
            {recentOrganizations.length === 0 && <li>No organizations yet</li>}
          </ul>
        </div>

        <div className="dashboard-card">
          <h3>
            <span>👥</span> Employees
          </h3>
          <div className="stat-number">{employees.length}</div>
          <p>Total registered employees</p>

          <h4 style={{ marginTop: "1.5rem" }}>Recently Registered</h4>
          <ul className="recent-list">
            {recentEmployees.map((emp) => (
              <li key={emp.id}>
                <span>
                  {emp.firstName} {emp.lastName}
                </span>
                <span>{emp.hireDate}</span>
              </li>
            ))}
            {recentEmployees.length === 0 && <li>No employees yet</li>}
          </ul>
        </div>

        <div className="dashboard-card">
          <h3>
            <span>🔗</span> Role Assignments
          </h3>
          <div className="stat-number" style={{ color: "#9b59b6" }}>
            {employees.filter((emp) => emp.roleId).length} / {employees.length}
          </div>
          <p>Employees with assigned roles</p>

          <div style={{ marginTop: "1rem" }}>
            <div
              style={{
                backgroundColor: "#ecf0f1",
                height: "10px",
                borderRadius: "5px",
                overflow: "hidden",
                marginBottom: "0.5rem",
              }}
            >
              <div
                style={{
                  width: `${
                    (employees.filter((emp) => emp.roleId).length /
                      employees.length) *
                      100 || 0
                  }%`,
                  backgroundColor: "#9b59b6",
                  height: "100%",
                  transition: "width 0.5s ease",
                }}
              ></div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "0.9rem",
              }}
            >
              <span>
                Assigned: {employees.filter((emp) => emp.roleId).length}
              </span>
              <span>Total: {employees.length}</span>
            </div>
          </div>

          <button
            className="action-btn"
            style={{
              backgroundColor: "#9b59b6",
              color: "white",
              marginTop: "1rem",
              width: "100%",
            }}
            onClick={() => setActiveView("employees")}
          >
            <span>👥</span> Manage Employee Roles
          </button>
        </div>

        <div className="dashboard-card">
          <h3>
            <span>⚡</span> Quick Actions
          </h3>
          <p>Perform quick actions in the system</p>

          <div className="action-buttons">
            <button
              className="action-btn primary"
              onClick={() => setActiveView("add-organization")}
            >
              <span>➕</span> Add Organization
            </button>

            <button
              className="action-btn secondary"
              onClick={() => setActiveView("add-employee")}
            >
              <span>➕</span> Add Employee
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
